module.exports = __webpack_public_path__ + "img/flamegunner_sergeant_small.2c0b3412.png";